export enum UpsellNames {
  HYPE = 'hype',
  CHARTS = 'charts',
}

export enum UpsellStatusNames {
  PAID = 'paid',
  FREE = 'free',
  REFUNDED = 'refunded',
  GROOVER_PLUS = 'groover-plus',
}

/**Non exhaustive list of promo kinds */
export enum PromoKind {
  GROOVER_PLUS = 'Groover Plus Subscription',
  PROGRESSIVE = 'Progressive',
}
